import type {
  EvaluationTemplate,
  EvaluationTemplateVersion,
  PatchEvaluationTemplateBody,
  UpsertEvaluationTemplateBody,
} from '../types/evaluationTemplate.js';

export interface IEvaluationTemplatesService {
  list(workspaceName: string): Promise<EvaluationTemplate[]>;
  get(workspaceName: string, name: string): Promise<EvaluationTemplate>;
  create(
    workspaceName: string,
    name: string,
    body: UpsertEvaluationTemplateBody,
  ): Promise<EvaluationTemplate>;
  replace(
    workspaceName: string,
    name: string,
    body: UpsertEvaluationTemplateBody,
  ): Promise<EvaluationTemplate>;
  patch(
    workspaceName: string,
    name: string,
    body: PatchEvaluationTemplateBody,
  ): Promise<EvaluationTemplate>;
  delete(workspaceName: string, name: string): Promise<void>;
  snapshot(
    workspaceName: string,
    name: string,
  ): Promise<EvaluationTemplateVersion>;
  listVersions(
    workspaceName: string,
    name: string,
  ): Promise<EvaluationTemplateVersion[]>;
  getVersion(
    workspaceName: string,
    name: string,
    version: number,
  ): Promise<EvaluationTemplateVersion>;
}

export class EvaluationTemplateNotFoundError extends Error {
  readonly code = 'EvaluationTemplateNotFound';
  constructor(workspaceName: string, name: string) {
    super(
      `Eval template '${name}' was not found in workspace '${workspaceName}'.`,
    );
  }
}

export class EvaluationTemplateAlreadyExistsError extends Error {
  readonly code = 'ResourceAlreadyExists';
  constructor(workspaceName: string, name: string) {
    super(
      `An eval template named '${name}' already exists in workspace '${workspaceName}'.`,
    );
  }
}
